module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_footer_image_01-b5092e25d768b6b46ded5f4f3b93b45d.jpg";